'use client';

import { useState } from 'react';
import { useIsCdpAuthEnabled } from 'apps/base-dev-frontend/core/auth/CDPAuthProvider';
import { GlobalBanner } from '@redesign/components/dashboard/shared/global-banner/global-banner';
import { ButtonContext } from '@redesign/utils/logging';

export function ReturningUserBanner() {
  const cdpAuthEnabled = useIsCdpAuthEnabled();
  const [isDismissed, setIsDismissed] = useState(false);

  if (!cdpAuthEnabled || isDismissed) return null;

  return (
    <GlobalBanner
      dismissLogContext={ButtonContext.landing.dismissReturningUserBanner}
      onDismiss={() => setIsDismissed(true)}
    >
      Returning user? Continue with{' '}
      <span className="text-gradient-blue font-medium">Coinbase Wallet</span> (previously Base
      Account).
    </GlobalBanner>
  );
}
